import {first} from 'rxjs/operators';
import { HasChanges } from './HasChanges';
import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../general/confirmationDialog.component';

@Injectable({ providedIn: 'root' })
export class ExistingChangesGuard implements CanDeactivate<HasChanges> {
    
    constructor(private dialog: MatDialog) {}

    canDeactivate(target: HasChanges) {
        if (target.hasChanges()) {
            return this.dialog.open(ConfirmationDialogComponent, { data: {title: target.existingChangesMessage(), actionLabel: 'Continue'}}).afterClosed().pipe(first());
        }
        return true;
    }

}